import React, { useEffect, useState } from 'react';
import { TabContent, TabPane, Container, Row, Col, Card, CardBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Medicine } from './searchTypes';
import TabNavigation from './TabNavigation';
import MedicineSearchInput from './MedicineSearchInput';
import MedicineTable from './MedicineTable';
import {
  addTab,
  removeTab,
  setActiveTab,
  addMedicineToTab,
  loadTabsFromStorage,
  updateMedicineInTab,
  removeMedicineFromTab,
} from 'store/sales-invoice/saleInvoice.actions';
import { Tab } from 'store/sales-invoice/medicineSearch.reducer';
import { SaleInvoiceProperties } from 'store/sales-invoice/selector';

const MedicineSearchTabs: React.FC = () => {
  const { i18n } = useTranslation();
  const isUrdu = i18n.language === 'ur' || i18n.dir() === 'rtl';
  const dispatch = useDispatch();

  const { tabs, activeTab, activeTabId, activeTabMedicines } = useSelector(SaleInvoiceProperties);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleTab = (tabId: string) => {
    dispatch(setActiveTab(tabId));
  };

  const addNewTab = () => {
    const newId = Date.now().toString();
    const newName = `Tab ${tabs.length + 1}`;
    dispatch(addTab(newId, newName));
  };

  const removeTabHandler = (tabId: string) => {
    dispatch(removeTab(tabId));
  };

  const handleInputChange = () => {
    setDropdownOpen(true);
  };

  const handleAddMedicine = (tabId: string, medicine: Medicine) => {
    dispatch(addMedicineToTab(tabId, { ...medicine, units: 1 }));
    setDropdownOpen(false);
  };

  const handleUnitChange = (medicineId: string, units: number) => {
    const medicineToUpdate = activeTabMedicines.find((m: Medicine) => m.id === medicineId);
    if (medicineToUpdate && activeTabId) {
      const updatedMedicine = { ...medicineToUpdate, units: units };
      dispatch(updateMedicineInTab(activeTabId, updatedMedicine));
    }
  };

  // const getCheaperEquivalent = (medicine: Medicine) => {
  //   return undefined; //medicine.equivalents.find((eq) => eq.price < medicine.price);
  // };

  // const handleSwapMedicine = (tabId: number, currentMedId: string, replacement: Medicine) => {
  //   setTabs((prev) =>
  //     prev.map((tab) =>
  //       tab.id === tabId
  //         ? {
  //             ...tab,
  //             selectedMedicines: tab.selectedMedicines.map((item) =>
  //               item.medicine.id === currentMedId ? { ...item, medicine: replacement } : item,
  //             ),
  //           }
  //         : tab,
  //     ),
  //   );
  // };

  const handleSwapMedicine = (tabId: string, currentMedId: string, replacement: Medicine) => {
    console.log('swap');
  };

  const handleRemoveMedicine = (medicineId: string) => {
    if (activeTabId) {
      dispatch(removeMedicineFromTab(activeTabId, medicineId));
    }
  };

  const printInvoice = () => {
    window.print();
  };

  useEffect(() => {
    dispatch(loadTabsFromStorage());
  }, [dispatch]);

  return (
    <div className="page-content">
      <Container fluid>
        <TabNavigation
          tabs={tabs}
          activeTab={activeTabId}
          isUrdu={isUrdu}
          toggleTab={toggleTab}
          addNewTab={addNewTab}
          removeTab={removeTabHandler}
        />
        <TabContent activeTab={activeTabId ?? ''}>
          {tabs.map((tab: Tab) => (
            <TabPane key={tab.id} tabId={tab.id}>
              <Row>
                <Col lg="12">
                  <Card>
                    <CardBody>
                      <MedicineSearchInput
                        tab={tab}
                        dropdownOpen={dropdownOpen}
                        setDropdownOpen={setDropdownOpen}
                        isUrdu={isUrdu}
                        onInputChange={handleInputChange}
                        onAddMedicine={handleAddMedicine}
                        showShortcuts={true}
                      />
                      <MedicineTable
                        tab={activeTab}
                        isUrdu={isUrdu}
                        handleRemoveMedicine={handleRemoveMedicine}
                        getCheaperEquivalent={() => undefined}
                        onSwapMedicine={handleSwapMedicine}
                        onUnitChange={handleUnitChange}
                        printInvoice={printInvoice}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
          ))}
        </TabContent>
      </Container>
    </div>
  );
};

export default MedicineSearchTabs;
